import React, { FC, useState } from 'react';
import EstimatesGraph from '../savigProfile/graph/EstimatesGraph';
import { estimatesYears, MultiGraphData } from './useHistoricGraphData';
import EstimateLegend from './EstimateLegend';
import { useTranslate } from '../../../../../hooks/useTranslate';

type HistoricDevelopmentProps = {
    graphData: MultiGraphData;
};
const HistoricDevelopment: FC<HistoricDevelopmentProps> = ({ graphData }) => {
    const [selectedFunds, setSelectedFunds] = useState<string[]>([]);
    const translate = useTranslate();
    const years = estimatesYears;

    return (
        <>
            <span className="paragraph">{translate('historicDevelopmentDescription', { years })}</span>
            <h3>{translate('historicDevelopmentLabel', { years })}</h3>
            <EstimatesGraph graphData={graphData} selectedFunds={selectedFunds} setSelectedFunds={setSelectedFunds} />
            <EstimateLegend legendData={graphData.graphDataSet} selectedFunds={selectedFunds} />
        </>
    );
};

export default HistoricDevelopment;
